<div>
  <form [formGroup]="stepFormGroup" class="step-container">
    <h3><strong>Arcada Inferior</strong></h3>
    <mat-card class="card-general">
      <mat-card-title>Extracciones Inferiores</mat-card-title>
      <mat-card-content class="mt-2 d-flex flex-column gap-5">
        <div class="row w-100 w-sm-75 justify-content-start">
          <p class="col text-start">¿Extraer digitalmente las piezas dentales?</p>
          <mat-radio-group aria-label="Seleciona una opción" formControlName="lowerArchHasExtractions" class="col d-flex flex-wrap gap-4">
            <div class="row gx-4 gy-2" *ngFor="let item of booleanOptions">
              <mat-radio-button [value]="item.value"
                [checked]="item.value == getControl(stepFormGroup,'lowerArchHasExtractions')" class="col py-6"
              ><span style="white-space:normal;">{{item.display}}</span></mat-radio-button>
            </div>
          </mat-radio-group>
        </div>
        <div class="row justify-content-center" *ngIf="getControl(stepFormGroup,'lowerArchHasExtractions')">
          <app-pieces-container [selectedPieces]="stepFormGroup?.controls['lowerArchDigitalExtractionPieces'].value" [numberPieces]=7 [axesDisabled]=[1,2] (piecesSelected)="onSetPieces($event, stepFormGroup, 'lowerArchDigitalExtractionPieces')"></app-pieces-container>
        </div>
        <div class="row gy-3 w-100 align-items-center">
          <div class="col-12 col-lg-10 text-center">
            <textarea maxlength="620" matInput placeholder="Ingresar comentarios..." name="lowerArchExtractionsComments" formControlName="lowerArchExtractionsComments" style="height: 120px;"></textarea>
          </div>
          <div class="col-12 col-lg-2 text-center">
            <img style="max-width: 200px;" src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-images/prescription/Dientes-09.svg" />
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card class="card-general">
      <mat-card-title>Espacios Inferiores</mat-card-title>
      <mat-card-content class="mt-2 d-flex flex-column gap-5">
        <div class="row w-100 w-sm-75 justify-content-start">
          <p class="col text-start">Dejar espacio en una zona en espec&iacute;fico</p>
          <mat-radio-group aria-label="Seleciona una opción" formControlName="lowerArchLeaveSpaceInSpecifiArea" class="col d-flex flex-wrap gap-4">
            <div class="row gx-4 gy-2" *ngFor="let item of booleanOptions">
              <mat-radio-button [value]="item.value"
                                [checked]="item.value == getControl(stepFormGroup,'lowerArchLeaveSpaceInSpecifiArea')" class="col py-6"><span style="white-space:normal;">{{item.display}}</span></mat-radio-button>
            </div>
          </mat-radio-group>
        </div>
        <div class="row w-100 w-sm-75 justify-content-start">
          <p class="col text-start">Apretar (-0.1mm) los contactos posteriores para evitar empaquetamiento:</p>
          <mat-radio-group aria-label="Seleciona una opción" formControlName="lowerArchTightenRearContacts" class="col d-flex flex-wrap gap-4">
            <div class="row gx-4 gy-2" *ngFor="let item of booleanOptions">
              <mat-radio-button [value]="item.value"
                                [checked]="item.value == getControl(stepFormGroup,'lowerArchTightenRearContacts')" class="col py-6"><span style="white-space:normal;">{{item.display}}</span></mat-radio-button>
            </div>
          </mat-radio-group>
        </div>

        <div class="row gy-3 w-100 align-items-center">
          <div class="col-12 col-lg-10 text-center">
            <textarea maxlength="620" matInput placeholder="Ingresar comentarios..." name="lowerArchSpacesInstructions" formControlName="lowerArchSpacesInstructions" style="height: 120px;"></textarea>
          </div>
          <div class="col-12 col-lg-2 text-center">
            <img style="max-width: 200px;" src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-images/prescription/Dientes-09.svg" />
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card class="card-general">
      <mat-card-title>Expansi&oacute;n Dental Inferior</mat-card-title>
      <mat-card-content class="mt-2 d-flex flex-column gap-5">
        <div class="row w-100">
          <div class="col-12 col-lg-10">
            <div class="row w-100 mb-5 justify-content-start">
              <p class="col text-start">Distancia intercanina: </p>
              <mat-radio-group aria-label="Seleciona una opción" formControlName="lowerArchIntercanineDistance" class="col d-flex flex-wrap gap-4">
                <div class="row gx-4 gy-2" *ngFor="let item of booleanDescriptionOptions">
                  <mat-radio-button [value]="item.value"
                                    [checked]="item.value == getControl(stepFormGroup,'lowerArchIntercanineDistance')" class="col py-6"><span style="white-space:normal;">{{item.display}}</span></mat-radio-button>
                </div>
              </mat-radio-group>
            </div>
            <div class="row w-100 mb-5 justify-content-start">
              <p class="col text-start">Expansión Dental Posterior (ampliar formas de arco):</p>
              <mat-radio-group aria-label="Seleciona una opción" formControlName="lowerArchPosteriorDentalExpansion" class="col d-flex flex-wrap gap-4">
                <div class="row gx-4 gy-2" *ngFor="let item of booleanOptions">
                  <mat-radio-button [value]="item.value"
                                    [checked]="item.value == getControl(stepFormGroup,'lowerArchPosteriorDentalExpansion')" class="col py-6"><span style="white-space:normal;">{{item.display}}</span></mat-radio-button>
                </div>
              </mat-radio-group>
            </div>

            <div class="row w-100 mb-5  justify-content-start">
              <p class="col text-start">
                Realizar Sobreexpansi&oacute;n posterior de
                <mat-form-field matInput style="width: fit-content;">
                  <mat-select formControlName="lowerArchPosteriorDentalExpansionDistance" class="text-center">
                    <mat-option *ngFor="let item of selectNumberOptions" [value]="item">
                      {{item}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                mm por lado
              </p>
            </div>
          </div>
          <div class="col-12 col-lg-2 text-center">
            <div class="col-12">
              <img style="max-width: 200px;" src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-images/prescription/Arcadas%20individuales-21.svg" />
            </div>
          </div>
        </div>

      </mat-card-content>
    </mat-card>

    <mat-card class="card-general">
      <mat-card-title>Pulido Interproximal Inferior</mat-card-title>
      <mat-card-content class="mt-2 d-flex flex-column gap-5">
        <div class="row w-100 justify-content-start">
          <mat-radio-group aria-label="Seleciona una opción" formControlName="lowerArchInterproximalPolishingType" class="col-12 col-lg-10  d-flex flex-wrap flex-column gap-4">
            <div class="d-flex align-items-center gap-4" *ngFor="let item of interproximalPolishingOptions">
              <mat-radio-button [value]="item.value" (click)="resetFormControl(stepFormGroup, 'lowerArchInterproximalPolishingQuantity')"
                                [checked]="item.value == getControl(stepFormGroup,'lowerArchInterproximalPolishingType')">
                <span style="white-space:normal;">{{item.display}}</span>
              </mat-radio-button>
              <mat-form-field matInput style="width: fit-content;" *ngIf="item.value == 2 && item.value == getControl(stepFormGroup,'lowerArchInterproximalPolishingType')">
                <mat-select formControlName="lowerArchInterproximalPolishingQuantity" class="text-center">
                  <mat-option *ngFor="let item of selectNumberTenthsOfMilimeterOptions" [value]="item">
                    {{item}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </mat-radio-group>
          <div class="col-12 col-lg-2 text-center">
            <img style="max-width: 200px;" src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-images/prescription/Dientes-09.svg" />
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card class="card-general">
      <mat-card-title>L&iacute;nea Media Inferior</mat-card-title>
      <mat-card-content class="mt-2 d-flex flex-column gap-5">
        <div class="row w-100  justify-content-start">
          <mat-radio-group aria-label="Seleciona una opción" formControlName="lowerArchMidLineType" class="col d-flex flex-wrap flex-column gap-4">
            <div class="d-flex align-items-center gap-4" *ngFor="let item of midLineTypeOptions">
              <mat-radio-button [value]="item.value" (click)="resetFormControl(stepFormGroup, 'lowerArchMidLineDistance')"
                                [checked]="item.value == getControl(stepFormGroup,'lowerArchMidLineType')">
                <span style="white-space:normal;">{{item.display}}</span>
                <span *ngIf="showMilimetersInMidLineType(item.value)"> mm</span>
              </mat-radio-button>
              <mat-form-field matInput style="width: fit-content;height: fit-content;" *ngIf="item.value == getControl(stepFormGroup,'lowerArchMidLineType') && item.value != 0">
                <mat-select formControlName="lowerArchMidLineDistance" class="text-center">
                  <mat-option *ngFor="let item of selectNumberOptions" [value]="item">
                    {{item}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </mat-radio-group>
        </div>
        <div class="row gy-3 w-100 align-items-center">
          <div class="col-12 col-lg-10 text-center">
            <textarea maxlength="620" matInput placeholder="Ingresar comentarios..." name="lowerArchManagementComments" formControlName="lowerArchManagementComments" style="height: 120px;"></textarea>
          </div>
          <div class="col-12 col-lg-2 text-center">
            <img style="max-width: 200px;" src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-images/prescription/Dientes-12.svg" />
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <div class="d-flex justify-content-center gap-4" *ngIf="isCaseDetail">
      <button mat-button matStepperPrevious class="button secondary-button"><mat-icon>chevron_left</mat-icon> Anterior</button>
      <button mat-button matStepperNext data-testid="nextStep4" class="button secondary-button" (click)="updateStepPrescription()" [disabled]="disabledButtonStages()">Guardar y Continuar <mat-icon>chevron_right</mat-icon></button>
    </div>
  </form>
</div>
